(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('realty-type', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/realty-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.realtyType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/realty-type/realty-types.html',
                    controller: 'RealtyTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('realtyType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('realty-type-detail', {
            parent: 'realty-type',
            url: '/realty-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.realtyType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/realty-type/realty-type-detail.html',
                    controller: 'RealtyTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('realtyType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RealtyType', function($stateParams, RealtyType) {
                    return RealtyType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'realty-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('realty-type-detail.edit', {
            parent: 'realty-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/realty-type/realty-type-dialog.html',
                    controller: 'RealtyTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RealtyType', function(RealtyType) {
                            return RealtyType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('realty-type.new', {
            parent: 'realty-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/realty-type/realty-type-dialog.html',
                    controller: 'RealtyTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                code: null,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('realty-type', null, { reload: 'realty-type' });
                }, function() {
                    $state.go('realty-type');
                });
            }]
        })
        .state('realty-type.edit', {
            parent: 'realty-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/realty-type/realty-type-dialog.html',
                    controller: 'RealtyTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RealtyType', function(RealtyType) {
                            return RealtyType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('realty-type', null, { reload: 'realty-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('realty-type.delete', {
            parent: 'realty-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/realty-type/realty-type-delete-dialog.html',
                    controller: 'RealtyTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RealtyType', function(RealtyType) {
                            return RealtyType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('realty-type', null, { reload: 'realty-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
